import ModalPortal from '@/components/ModalPortal/ModalPortal';
import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import ShareModal from '@uikit/components/Share/ShareModal/ShareModal';
import ShareOption from '@uikit/components/ShareOption/ShareOption';
import { useState } from 'react';
import PageHeader from '../PageHeader/PageHeader';
import { ShareActionProps } from './types';

const ShareAction = ({
  headline = 'Diesen Artikel teilen',
  label = 'Teilen',
  text,
  title,
  url,
}: ShareActionProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useIsMobile(1200);

  const handleOnClick = async () => {
    if (navigator.share && isMobile) {
      navigator.share({
        title: title,
        text: text,
        url: url,
      });
    } else {
      if (!isModalOpen) {
        setIsModalOpen(true);
      }
    }
  };

  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <PageHeader.Action
        icon="action/share"
        onClick={handleOnClick}
        title={label}
      />

      <ModalPortal
        disableCloseIcon
        id={`share-modal-${title}`}
        key={`share-modal-${title}`}
        mainLayerVisible={true}
        onClose={handleClose}
        show={isModalOpen}
        variant="shade"
      >
        <ShareModal handleClose={handleClose} headline={headline}>
          <ShareOption text={title} variant="linkCopy" />
          <ShareOption text={title} variant="eMail" />
          <ShareOption text={title} variant="facebook" />
          <ShareOption text={title} variant="twitter" />
          <ShareOption text={title} variant="xing" />
          <ShareOption text={title} variant="linkedIn" />
        </ShareModal>
      </ModalPortal>
    </>
  );
};

export default ShareAction;
